import Icon from '../components/Icon.vue'

Icon.register({
  'arrows-alt-v': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M214.1 377.9c21.4 0 32.1 25.9 17 41l-86.1 86.1c-9.4 9.4-24.6 9.4-33.9 0l-86.1-86.1c-15.1-15.1-4.4-41 17-41h46.1v-243.9h-46.1c-21.4 0-32.1-25.9-17-41l86.1-86.1c9.4-9.4 24.6-9.4 33.9 0l86.1 86.1c15.1 15.1 4.4 41-17 41h-46.1v243.9h46.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrows-alt-v.js
// module id = 628
// module chunks = 0